import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createLanguageSlice = createAsyncThunk(
  "language/createLanguage",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/language/createLanguage", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getLanguageSlice = createAsyncThunk(
  "language/getAllLanguage",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/language/getAllLanguage",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateLanguageSlice = createAsyncThunk(
  "language/updateLanguage",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/language/updateLanguage", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteLanguageSlice = createAsyncThunk(
  "language/deleteLanguage",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/language/deleteLanguage", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  languages: [],
  createSuccessMessage: null,
  createErrorMessage: null,
  updateSuccessMessage: null,
  updateErrorMessage: null,
  deleteSuccessMessage: null,
  deleteErrorMessage: null,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    resetCreateMessages: (state) => {
      state.createSuccessMessage = null;
      state.createErrorMessage = null;
    },
    resetUpdateMessages: (state) => {
      state.updateSuccessMessage = null;
      state.updateErrorMessage = null;
    },
    resetDeleteMessages: (state) => {
      state.deleteSuccessMessage = null;
      state.deleteErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createLanguageSlice.pending, (state) => {
        state.loading = true;
        state.createSuccessMessage = null;
        state.createErrorMessage = null;
      })
      .addCase(createLanguageSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.createErrorMessage = action.payload.result.message;
        } else {
          state.createSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(createLanguageSlice.rejected, (state, action) => {
        state.loading = false;
        state.createErrorMessage = action.payload.result.message;
      })
      .addCase(getLanguageSlice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getLanguageSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
        }
        state.languages = action.payload.result.list;
      })
      .addCase(getLanguageSlice.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateLanguageSlice.pending, (state) => {
        state.loading = true;
        state.updateSuccessMessage = null;
        state.updateErrorMessage = null;
      })
      .addCase(updateLanguageSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateErrorMessage = action.payload.result.message;
        } else {
          state.updateSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateLanguageSlice.rejected, (state, action) => {
        state.loading = false;
        state.updateErrorMessage = action.payload.result.message;
      })
      .addCase(deleteLanguageSlice.pending, (state) => {
        state.loading = true;
        state.deleteSuccessMessage = null;
        state.deleteErrorMessage = null;
      })
      .addCase(deleteLanguageSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteErrorMessage = action.payload.result.message;
        } else {
          state.deleteSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(deleteLanguageSlice.rejected, (state, action) => {
        state.loading = false;
        state.deleteErrorMessage = action.payload.result.message;
      });
  },
});

export const { resetCreateMessages, resetUpdateMessages, resetDeleteMessages } =
  languageSlice.actions;
export default languageSlice.reducer;
